import router from '@/router'

export default {
  /**
   * エラーページにリダイレクトする
   * @param {object} errorResponse
   */
  redirectErrorPage: function(errorResponse) {
    if (errorResponse.status <= 599 && errorResponse.status >= 500) {
      const message =
        errorResponse.data.message === undefined
          ? String(errorResponse.data)
          : errorResponse.data.message
      router.push({
        name: '500Error',
        params: { code: errorResponse.status, message: message },
      })
    }
  },
}
